import { Observable } from 'rxjs/Observable';
import ajax from '@ui/services/api/ajax';

export interface UserApi {
  getManagers: () => Observable<any>;
  createManager: (manager: any) => Observable<any>;
  editManager: (manager: any) => Observable<any>;
}

export const userApi: UserApi = {
  getManagers: () => ajax.get({ url: 'user/managers' }),
  createManager: manager =>
    ajax.post({
      url: 'user/create',
      body: { manager: JSON.stringify(manager) },
    }),
  editManager: manager =>
    ajax.post({
      url: 'user/edit',
      body: { manager: JSON.stringify(manager) },
    }),
};



// WEBPACK FOOTER //
// ./src/api/user/user.ts